import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callContractorPortalSecureApi } from '../api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import {
  ContractorPortalFetchDriver,
  ContractorPortalUploadDebitCard,
} from 'src/constants/actionTypes'
import { PaymentMethodTypeEnum } from 'src/interfaces/paymentMethod'

interface ContractorPortalDebitCardRequest {
  cardNumber: string
  cardExpiration: string
  zipcode: string
  token?: string | null
}

function* onContractorPortalUploadDebitCard(action: AsyncAction<ContractorPortalDebitCardRequest>) {
  const { cardNumber, cardExpiration, zipcode, token } = action.payload

  try {
    yield call(callContractorPortalSecureApi, Endpoints.FetchPaymentMethod, {
      method: 'POST',
      query: token ? { token } : undefined,
      body: {
        paymentMethodType: PaymentMethodTypeEnum.Card,
        cardDetails: {
          cardNumber,
          cardExpiration,
          zipcode,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(ContractorPortalUploadDebitCard.success())

    yield put(ContractorPortalFetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to upload debit card'

    yield put(ContractorPortalUploadDebitCard.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* contractorPortalDebitCardSaga() {
  yield takeLatest(ContractorPortalUploadDebitCard.type.REQUEST, onContractorPortalUploadDebitCard)
}
